import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import 'url-search-params-polyfill';
import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    Button,
    Input,
    ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {fetchPBN, playCard, resetCards} from "../actions";


function isPositiveInteger(s) {
    return /^\+?[1-9][\d]*$/.test(s);
}

class PBNViewerControl extends Component {
    constructor(props) {
        super(props);

        let params = new URLSearchParams(this.props.location.search);

        let type = '4hands';
        if (params.has('type')) {
            let paramType = params.get('type');
            if (paramType === 'tournament') {
                type = 'tournament';
            }
        }

        let game = '';
        if (params.has('game')) {
            let paramGame = params.get('game');
            if (isPositiveInteger(paramGame)) {
                game = paramGame;
            }
        }

        let table = '';
        if (params.has('table')) {
            let paramTable = params.get('table');
            if (isPositiveInteger(paramTable)) {
                table = paramTable;
            }
        }

        let board = '';
        if (params.has('board')) {
            let paramBoard = params.get('board');
            if (isPositiveInteger(paramBoard)) {
                board = paramBoard;
            }
        }

        this.state = {
            gameType: type,
            gameId: game,
            table: table,
            boardNum: board,
            expanded: true

        };

        this.submit = this.submit.bind(this);
    }


    submit(e) {
        e.preventDefault();

        let table = 1;
        if (this.state.gameType === "tournament") {
            if (!isPositiveInteger(this.state.table)) {
                return;
            }

            table = parseInt(this.state.table);
        }

        if (!isPositiveInteger(this.state.gameId)) {
            return;
        }

        let game = parseInt(this.state.gameId);

        if (!isPositiveInteger(this.state.boardNum)) {
            return;
        }

        let board = parseInt(this.state.boardNum);
        this.props.history.push('?type=' + this.state.gameType + '&game=' + game + '&table=' + table + '&board=' + board);
        this.props.onSubmitClick(this.state.gameType, game, table, board);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    }

    handlePanelChange = (event, expanded) => {
        this.setState({
            expanded: expanded
        })
    }

    render() {
        return (
            <ExpansionPanel expanded={this.state.expanded} onChange={this.handlePanelChange} style={{margin:5, padding:5}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{margin:0, padding:0}}>
                    <Typography>Load Hand</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails >
                    <form onSubmit={this.submit} style={{width:'100%'}}>
                        <Grid container spacing={8} alignItems={"center"}>
                            <Grid item sm={3} xs={12} >
                                <FormControl fullWidth>
                                    <Select
                                        value={this.state.gameType}
                                        onChange={this.handleChange('gameType')}
                                    >
                                        <MenuItem value={'4hands'}>4-hands</MenuItem>
                                        <MenuItem value={'tournament'}>Tournament</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={2} xs={12} >
                                <Input
                                    fullWidth
                                    inputProps={{
                                        style: {fontSize: 15}
                                    }
                                    }
                                    placeholder="Game"
                                    value={this.state.gameId}
                                    margin="none"
                                    onChange={this.handleChange('gameId')}
                                />
                            </Grid>
                            <Grid item sm={2} xs={12}>
                                <Input
                                    fullWidth
                                    placeholder="Table"
                                    value={this.state.table}
                                    margin="none"
                                    onChange={this.handleChange('table')}
                                    disabled={this.state.gameType==='4hands'}
                                />
                            </Grid>
                            <Grid item sm={2} xs={12}>
                                <Input
                                    fullWidth
                                    placeholder="Board"
                                    value={this.state.boardNum}
                                    margin="none"
                                    onChange={this.handleChange('boardNum')}
                                />
                            </Grid>
                            <Grid item sm={3} xs={12}>
                                <Button type={"submit"} variant={"outlined"}>Load Hand</Button>
                            </Grid>
                        </Grid>
                    </form>
                </ExpansionPanelDetails>
            </ExpansionPanel>

        );
    }
}

PBNViewerControl.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    onSubmitClick: PropTypes.func.isRequired
}

function mapStateToProps(state, ownProps){
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmitClick: function (gameType, game, table, board) {
            dispatch(fetchPBN(gameType, game, table, board));
        }
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PBNViewerControl)
)